import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class EvaluationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllEvaluation(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.evaluationUrl}/all`,
			'getAllEvaluation'
		);
	}


	getEvaluationById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.evaluationUrl}/get/${id}`,
			'getEvaluationById'
		);
	}

	updateEvaluation(evaluation: Prestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.evaluationUrl}/update/${evaluation.id}`,
			'updateEvaluation',
			evaluation
		);
	}

	addEvaluation(evaluation: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.evaluationUrl}/add`,
			'addEvaluation',
			evaluation
		);
	}

	deleteEvaluation(evaluationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.evaluationUrl}/delete/${evaluationId}`,
			`deleteEvaluation`
		);
	}

}
